import { useState, useRef } from "react";

function GeneralAccordion({ title, children }) {
  const [isOpen, setIsOpen] = useState(false);
  const contentRef = useRef(null);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className={`general-accordion ${isOpen ? "open" : ""}`}>
      <div
        className="general-accordion-header"
        onClick={toggleAccordion}
        style={{ cursor: "pointer" }}
      >
        <h3 className={isOpen ? "opened" : ""}>{title}</h3>
        <img
          src={`${process.env.PUBLIC_URL}/images/icons/${
            isOpen
              ? "general_accordion_opened_icon.svg"
              : "general_accordion_closed_icon.svg"
          }`}
          alt={isOpen ? "Close" : "Open"}
        />
      </div>

      <div
        ref={contentRef}
        className="general-accordion-content-wrapper"
        style={{
          maxHeight: isOpen ? `${contentRef.current.scrollHeight}px` : "0px",
          overflow: "hidden",
          transition: "max-height 0.3s ease-in-out", // This creates the smooth opening
        }}
      >
        <div className="general-accordion-content">{children}</div>
      </div>
    </div>
  );
}

export default GeneralAccordion;
